import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";

import "./services.css";

import service1 from "../../assets/images/SOBRE.png";
import service2 from "../../assets/images/SERVICOS.png";
import service3 from "../../assets/images/GALERIA.png";

import sobre from "../../assets/images/curitiba.jpg";

import Gallery from "../gallery/gallery";

import { useEffect, useState } from "react";

import {
  faBagShopping,
  faBasketball,
  faBasketShopping,
  faBellConcierge,
  faBriefcase,
  faBuildingColumns,
  faBurger,
  faCar,
  faCarSide,
  faChampagneGlasses,
  faCircleInfo,
  faClipboard,
  faDumbbell,
  faFilm,
  faFutbol,
  faGamepad,
  faHospital,
  faIndustry,
  faLandmarkFlag,
  faMicrophone,
  faPeopleGroup,
  faPersonSwimming,
  faSchool,
  faScrewdriverWrench,
  faShop,
  faStore,
  faTruckRampBox,
  faUserGroup,
  faUtensils,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";

const Services = () => {
  const [showAbout, setShowAbout] = useState(false);
  const [showServices, setShowServices] = useState(false);
  const [showGalery, setShowGalery] = useState(false);

  useEffect(() => {
    var about = document.getElementById("about");
    if (about) about.onclick = () => setShowAbout(true);

    var services = document.getElementById("services");
    if (services) services.onclick = () => setShowServices(true);

    var galery = document.getElementById("galery");
    if (galery) galery.onclick = () => setShowGalery(true);
  }, []);

  return (
    <div className="servicesColumn">
      <div className="servicesTitle">
        <p>CONHEÇA A EMPRESA</p>
      </div>

      <div className="services">
        <div className="service" id="services">
          <img src={service2} alt="" />
          <div className="serviceText">
            <div className="serviceDescription">SERVIÇOS</div>
          </div>
        </div>

        <div className="service" id="galery">
          <img src={service3} alt="" />
          <div className="serviceText">
            <div className="serviceDescription">GALERIA</div>
          </div>
        </div>

        <div className="service" id="about">
          <img src={service1} alt="" />
          <div className="serviceText">
            <div className="serviceDescription">SOBRE</div>
          </div>
        </div>
      </div>

      <Modal
        show={showAbout}
        size="lg"
        centered
        onHide={() => setShowAbout(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="modal-title">
              <FontAwesomeIcon className="aboutIcon" icon={faCircleInfo} />
              SOBRE A EMPRESA
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <img className="aboutImg" src={sobre} alt="" />
          <br />
          EMPRESA LOCALIZADA EM CURITIBA, ATUANDO HÁ MAIS DE 15 ANOS NO MERCADO
          DE SONORIZAÇÃO AMBIENTE NO SUL E SUDESTE DO PAÍS.
        </Modal.Body>
      </Modal>

      <Modal
        show={showServices}
        size="lg"
        centered
        onHide={() => setShowServices(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="modal-title">
              <FontAwesomeIcon className="servIcon" icon={faCircleInfo} />
              NOSSOS SERVIÇOS
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h4>SERVIÇOS GERAIS:</h4> <br />
          AVALIAÇÃO, DIAGNÓSTICO E SOLUÇÃO DE PROBLEMAS RELATIVOS A SONORIZAÇÃO
          E ACÚSTICA.
          <hr />
          <br />
          <h4>INSTALAÇÃO DE SOM EM AMBIENTES COMERCIAIS:</h4> <br />
          <div className="servicesDivider">
            <div className="servicesItem">
              <FontAwesomeIcon className="contactsPhoneIcon" icon={faStore} />
              LOJAS <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faBagShopping}
              />
              SHOPPINGS <br />
              <FontAwesomeIcon className="contactsPhoneIcon" icon={faCarSide} />
              CONCESSIONÁRIAS DE VEÍCULOS <br />
              <FontAwesomeIcon className="contactsPhoneIcon" icon={faShop} />
              CENTROS COMERCIAIS <br />
              <FontAwesomeIcon className="contactsPhoneIcon" icon={faBurger} />
              PRAÇAS DE ALIMENTAÇÃO <br />
              <FontAwesomeIcon className="contactsPhoneIcon" icon={faCar} />
              ESTACIONAMENTOS <br />
            </div>
            <div className="servicesItem">
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faDumbbell}
              />
              ACADEMIAS <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faUtensils}
              />
              RESTAURANTES <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faBellConcierge}
              />
              HOTÉIS <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faBasketShopping}
              />
              SUPERMERCADOS <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faHospital}
              />
              CLÍNICAS <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faChampagneGlasses}
              />
              CASAS NOTURNAS (BALADAS) <br />
            </div>
          </div>
          <hr />
          <br />
          <h4>INSTALAÇÃO AUDIOVISUAL EM AMBIENTES CORPORATIVOS:</h4> <br />
          <div className="servicesDivider">
            <div className="servicesItem">
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faBriefcase}
              />
              ESCRITÓRIOS E AUDITÓRIOS. <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faPeopleGroup}
              />
              SALAS DE REUNIÃO <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faPeopleGroup}
                color="#00000000"
              />
              E VIDEOCONFERÊNCIA
              <br />
            </div>
            <div className="servicesItem">
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faIndustry}
              />
              FÁBRICAS
              <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faTruckRampBox}
              />
              CENTROS DE DISTRIBUIÇÃO
              <br />
            </div>
          </div>
          <hr />
          <br />
          <h4>
            INSTALAÇÃO AUDIOVISUAL EM ESCOLAS E AMBIENTES ACADÊMICOS:
          </h4>{" "}
          <br />
          <div className="servicesDivider">
            <div className="servicesItem">
              <FontAwesomeIcon className="contactsPhoneIcon" icon={faFutbol} />
              CENTROS ESPORTIVOS <br />
              <FontAwesomeIcon className="contactsPhoneIcon" icon={faSchool} />
              SALAS DE AULA <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faSchool}
                color="#00000000"
              />
              (SOM SETORIZADO E <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faSchool}
                color="#00000000"
              />
              COM SIRENE MUSICAL) <br />
            </div>
            <div className="servicesItem">
              <FontAwesomeIcon className="contactsPhoneIcon" icon={faGamepad} />
              ÁREAS DE RECREAÇÃO <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faBasketball}
              />
              GINÁSIOS <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faPersonSwimming}
              />
              PISCINAS <br />
            </div>
          </div>
          <hr />
          <br />
          <h4>INSTALAÇÃO DE SOM EM IGREJAS</h4> <br />
          <div className="servicesDivider">
            <div className="servicesItem">
              - SISTEMA DE COLUNAS OU CONVENCIONAL <br />
            </div>
          </div>
          <hr />
          <br />
          <h4>INSTALAÇÃO DE SOM EM AMBIENTES PÚBLICOS</h4> <br />
          <div className="servicesDivider">
            <div className="servicesItem">
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faBuildingColumns}
              />
              MEMORIAIS <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faLandmarkFlag}
              />
              MUSEUS <br />
            </div>
            <div className="servicesItem">
              <FontAwesomeIcon className="contactsPhoneIcon" icon={faFilm} />
              CINEMAS <br />
              <FontAwesomeIcon className="contactsPhoneIcon" icon={faGamepad} />
              PARQUES TEMÁTICOS <br />
            </div>
          </div>
          <hr />
          <br />
          <h4>SISTEMAS OFERECIDOS</h4> <br />
          SISTEMA DE SONORIZAÇÃO SOBRE PROTOCOLO DE INTERNET: SOM SOBRE IP.
          UTILIZE SUA REDE DE CABOS DA INTERNET PARA TRANSMITIR SEU SOM
          (BROADCASTING).
          <br />
          <br />
          SISTEMA DE SOM ULTRASSÔNICO DIRECIONAL (FAÇA O SOM TOCAR EM UM PONTO
          ESPECÍFICO).
          <br />
          <br />
          SISTEMA DE MASCARAMENTO SONORO. UTILIZE O SOM PARA QUE SUAS CONVERSAS
          EM AMBIENTES ABERTOS NÃO SEJAM ENTENDIDAS PELOS OUTROS AO SEU REDOR.
          <br />
          <br />
          TRATAMENTO ACÚSTICO DE AMBIENTES REFLETIVOS. NEM SEMPRE EQUIPAMENTO
          AVANÇADO RESOLVE A QUESTÃO DA INTELIGIBILIDADE DE VOZ. UM TRATAMENTO
          ADEQUADO DO AMBIENTE RESOLVE ECOS E REFLEXÕES INDESEJADAS DO SOM.
          <br />
          <br />
          COM ORÇAMENTOS COMPETITIVOS, OFERECEMOS TODA A INFRAESTRUTURA PARA
          INSTALAÇÃO DE SONORIZAÇÃO, COMO CAIXAS DE SOM, ARANDELAS,
          AMPLIFICADORES, MICROFONES E FIAÇÃO. <br />
          <hr />
          <br />
          <h4>OPÇÕES DE SERVIÇO:</h4> <br />
          FORNECEMOS TAMBÉM:
          <div className="servicesDivider">
            <div className="servicesItem">
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faClipboard}
              />
              APENAS PROJETOS. <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faUserGroup}
              />
              APENAS ASSESSORIA. <br />
            </div>
            <div className="servicesItem">
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faMicrophone}
              />
              APENAS EQUIPAMENTOS. <br />
              <FontAwesomeIcon
                className="contactsPhoneIcon"
                icon={faScrewdriverWrench}
              />
              APENAS A INSTALAÇÃO. <br />
            </div>
          </div>
          <hr />
          <br />
          <h4>PEÇA UM ORÇAMENTO VIA WHATSAPP:</h4> <br />
          <div className="servicesWhatsapp" onClick={() => window.open("https://api.whatsapp.com/send?phone=41996074017")}>
          <FontAwesomeIcon className="contactsWhatsappIcon" icon={faWhatsapp} />
          (41) 99607-4017
          </div>
          <br />
        </Modal.Body>
      </Modal>

      <Modal
        show={showGalery}
        size="lg"
        centered
        onHide={() => setShowGalery(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="modal-title">
              <FontAwesomeIcon className="galeryIcon" icon={faCircleInfo} />
              GALERIA DE FOTOS
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Gallery />
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default Services;
